import axios from "axios";
const deployEnvironment = require("../../deployEnvironment.js");

const API = deployEnvironment;
const STORAGE_KEY = "accessToken";

class SuppliersApi {
  async getSuppliers() {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const getSuppliersResponse = await axios.get(
      `${API}/api/pa-supplier/getSuppliers`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const suppliers = getSuppliersResponse.data.suppliers;

    return new Promise((resolve, reject) => {
      try {
        if (!suppliers) {
          reject(new Error("Unauthorized"));
          return;
        }
        resolve(suppliers);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async getSupplierDetails(supplierId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    const getSupplierDetailsResponse = await axios.post(
      `${API}/api/pa-supplier/getSupplierDetails`,
      { supplierId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const supplierDetails = getSupplierDetailsResponse.data.supplierDetails;

    return new Promise((resolve, reject) => {
      try {
        if (!supplierDetails) {
          reject(new Error("Unauthorized"));
          return;
        }
        resolve(supplierDetails);
      } catch (err) {
        reject(new Error("Internal server error"));
      }
    });
  }
  async alterPortalAccess(supplierId) {
    const accessToken = sessionStorage.getItem(STORAGE_KEY);

    await axios.post(
      `${API}/api/pa-supplier/alterPortalAccess`,
      { supplierId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
  }
}

export const suppliersApi = new SuppliersApi();
